import { useQuery } from "@tanstack/react-query";

interface AppConfig {
  softLaunchMode: boolean;
}

async function fetchConfig(): Promise<AppConfig> {
  const res = await fetch("/api/config", { credentials: "include" });
  if (!res.ok) return { softLaunchMode: false };
  return res.json();
}

export interface SoftLaunchState {
  softLaunch: boolean;
  isLoading: boolean;
}

export function useSoftLaunch(): SoftLaunchState {
  const { data, isLoading } = useQuery<AppConfig>({
    queryKey: ["app-config"],
    queryFn: fetchConfig,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return {
    softLaunch: data?.softLaunchMode ?? false,
    isLoading,
  };
}
